<template>
  <div class="text-center" v-if="loading">
    <span>Loading</span><br>
  <CSpinner grow=true color="danger"></CSpinner>
  </div>
  <CCard v-else>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid" />Promotions
      </slot>
      <div class="float-right">
        <router-link :to="{ name: 'PromotionCreate'}">
          <button class="btn btn-success">Create New Promotion</button>
        </router-link>
      </div>
    </CCardHeader>
    <CCardBody>
      <v-client-table :data="promotions" :columns="columns" :options="options">
        <template slot="published_status" slot-scope="props">
          <div>
            <span v-if="props.row.published_status" class="badge badge-success badge-sm">published</span>
            <span v-else class="badge badge-warning badge-sm">unpublished</span>
          </div>
        </template>
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'PromotionEdit',  params: {id: props.row.id}}">
              <span
                class="btn btn-warning btn-sm m-1"
                data-toggle="tooltip"
                title="Edit"
                :href="props.row.id"
              >
                <CIcon name="cil-pencil" size="sm" />
              </span>
            </router-link>
            <span @click="pushNotification(props.row.id)"
                class="btn btn-success btn-sm m-1"
                data-toggle="tooltip"
                title="Push to Users"
            >
                <CIcon name="cil-check" size="sm" />
              </span>
          </div>
        </template>
      </v-client-table>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "Promotions",
  data() {
    return {
      loading : false,
      promotions: [],
      columns: ["id", "title", "body", "created_by", "published_status", "action"],
      options: {
        pagination: { nav: "fixed" },
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getPromotions();
  },
  methods: {
    getPromotions() {
      this.$axios
        .get(`${ADMIN_URL}/promotions`)
        .then((response) => {
          console.log("topics, response === ", response.data);
          this.promotions = response.data.data;
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    pushNotification(id)
    {
      this.loading = true
      this.$axios
          .post(`${ADMIN_URL}/promotions/push`,{
            id : id
          })
          .then((response) => {
            this.loading = false
            if(response.data.success)
            {
              this.$swal("Success", response.data.message, "success");
            }
            else
            {
              this.$swal("Error", response.data.message, "error");
            }
          })
          .catch((e) => {
             this.loading = false
            console.log("error occurs", e);
            this.$swal("Success", e.response.data.message, "success");
          });
    }
  },
};
</script>

<!--
<template>
  <div class="animated fadeIn">
    <div class="cardheading">
      <h4><i class="fa fa-file-image-o"></i><span class="ml-1">Categories</span></h4>
      <div class="">
        <h1 class="my-auto tableName">

        </h1>
      </div>
      <div class="">
        <router-link :to="{ name: 'CategoryCreate'}">
          <button class="btn btn-success">Create New Category</button>
        </router-link>
      </div>
    </div>
    <b-row>
      <b-col>
        <b-card>
          <v-client-table :data="category" :columns="columns" :options="options">
            <template slot="image" slot-scope="props">
              <div class="center-div">
                <img :src="`${BASE_URL}/${src_image}${props.row.image}`" style="width: 160px;height: 90px;">
              </div>
            </template>
            <template slot="action" slot-scope="props">
              <div>
                <router-link :to="{ name: 'Category / Edit', params: { id: props.row.id }}"><span class="btn btn-warning btn-sm m-1" data-toggle="tooltip" title="Edit" :href="props.row.id">
                                    <i class="fa fa-edit"></i></span></router-link>
                <span class="btn btn-danger btn-sm m-1" data-toggle="tooltip" title="Delete"> <i class="fa fa-trash"></i></span>
              </div>
            </template>
          </v-client-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>
  import axios from 'axios';
  const BASE_URL  = process.env.VUE_APP_BASE_URL;

  export default {
    name: 'Categories',
    data() {
      return {
        BASE_URL: BASE_URL,
        category : [],
        src_image : 'images/categories/',
        columns: ['image', 'title', 'service', 'type', 'status', 'created_at', 'action'],
        options: {
          pagination: {nav: 'fixed'},
          filterByColumn: true,
          toMomentFormat: 'YYYY-MM-DD',
          sortIcon: {base: 'fa fa-sort', up: 'fa fa-sort-up', down: 'fa fa-sort-down', is: 'fa fa-sort'},

        }

      }
    },
    created(){
      const Admin_URL = process.env.VUE_APP_ADMIN_URL;
      const BASE_URL  = process.env.VUE_APP_BASE_URL;
      axios.get(`${Admin_URL}/categories`)
              .then(response => {
                // console.log('B2CSections.vue, response === ', response.data);
                this.category = response.data;
              })
              .catch(e=>{
                //console.log("error occurs");
              });
    },
    methods: {

    },
  }
</script>
-->
